export const encodeForm  = (obj) => {
  const str = []
  Object.keys(obj).forEach((key) => {
    str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
  })
  return str.join('&')
}
